/* eslint-disable */

import React, { useEffect, Suspense, lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import i18next from 'i18next';
import _ from 'lodash';
import fixRatio from 'app/utils/fixRatio';
import history from 'app/utils/history';
import { isRTL as isRTLUtil, langList, defaultLang } from 'app/utils/lang';
import Loading from 'app/components/Loading';
import Controls from 'app/components/Controls';

const Home = lazy(() => import('app/containers/Home'));
const Bookmarks = lazy(() => import('app/containers/Bookmarks'));
const Preview = lazy(() => import('app/containers/Preview'));
const Play = lazy(() => import('app/containers/Play'));
const LiveTv = lazy(() => import('app/containers/LiveTv'));
const LiveAparat = lazy(() => import('app/containers/LiveAparat'));
const Search = lazy(() => import('app/containers/Search'));
const Login = lazy(() => import('app/containers/Login'));
const DirectLogin = lazy(() => import('app/containers/DirectLogin'));
const Profile = lazy(() => import('app/containers/Profile'));
const Details = lazy(() => import('app/containers/Details'));
const Grid = lazy(() => import('app/containers/Grid'));
const Payment = lazy(() => import('app/containers/Payment'));

let selectableRows = null;
let listContainerELement = null;
let videoItemMarginRight = null;
let videoItemWidth = null;
let videoListHeight = null;
let tagItemMargin = null;
let tagItemWidth = null;
let tagListHeight = null;
let interviewWrapper = null;
let interviewHeight = null;
let videoLists = null;
let tagLists = null;
let liveLists = null;
let liveItemMargin = null;
let liveItemWidth = null;
let liveListHeight = null;
let liveItemMarginRight = null;
let paginationWrapper = null;
let isRTL = isRTLUtil();

if (!isRTL) {
  document.body.classList.add('ltr');
}

const SentryRoute = ((process.env.NODE_ENV === 'production') && (process.env.SKIP_SENTRY !== 'false') && (_.get(process.env.APP_CONFIG, ['APP_DETAILS', 'EN_NAME'], '') === 'Filimo')) ? Sentry.withSentryRouting(Route) : Route;
const urlParts = (window.location.pathname).split('/');
const storedLang = localStorage.getItem('lang');

if (urlParts[1] && !(langList()).includes(urlParts[1])) {
  urlParts[1] = storedLang || defaultLang();
  history.push(urlParts.join('/'));
}

export default () => {
  const location = useLocation();

  const handleRTL = () => {
    setTimeout(() => {
      document.getElementsByTagName('html')[0].setAttribute('lang', localStorage.getItem('lang'));
    }, 500);
    isRTL = isRTLUtil();
    if (!isRTL) {
      document.body.classList.add('ltr');
    } else {
      document.body.classList.remove('ltr');
    }
  };

  useEffect(() => {
    i18next.on('languageChanged', () => {
      handleRTL();
      checkRenderedDom();
    });
    handleRTL();
    fixRatio(checkRenderedDom);
    let canChangeScroll = true;
    window.addEventListener('keydown', (event : any) => {
      switch (event.keyCode) {
        case 19:
        case 38:
          return verticalMove('up');
        case 20:
        case 40:
          return verticalMove('down');
        case 21:
        case 37:
          return horizontalMove(isRTL ? 'left' : 'right');
        case 22:
        case 39:
          return horizontalMove(isRTL ? 'right' : 'left');
        case 23:
        case 66:
        case 13:
          return handleClickActiveItem();
        case 4:
        case 461:
        case 187:
        case 10009:
          if (
            _.get(window, ['webOS', 'platform', 'tv'])
            && (_.get(window, ['location', 'pathname'], '') === `/${history.location.pathname.split('/')[1]}`)
            && !_.get(window, ['location', 'search'])
          ) {
            window.webOS.platformBack();
          } else {
            history.goBack();
          }
          break;
        default:
          return null;
      }
    });
    window.addEventListener('wheel', (data : any) => {
      if (canChangeScroll) {
        if (data.wheelDeltaY < -10) {
          verticalMove('down');
        } else if (data.wheelDeltaY > 10) {
          verticalMove('up');
        }
        canChangeScroll = false;
        setTimeout(() => {
          canChangeScroll = true;
        }, 200);
      }
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      checkRenderedDom();
    }, 500);
  }, [location.pathname]);

  const checkElementHasClass = (element : any, className : string) : boolean => {
    return ((` ${element.className} `).replace(/[\n\t]/g, ' ')
      .indexOf(` ${className} `) > -1);
  };

  const checkRenderedDom = () => {
    let interval = null;

    function handleCheckRenderedDom() {
      const videoListsItems = document.getElementsByClassName('videoList');
      const videoItems = document.getElementsByClassName('videoItem');
      const tagListsItems = document.getElementsByClassName('tagList');
      const liveListsItems = document.getElementsByClassName('liveList');
      const tagItems = document.getElementsByClassName('tagItem');
      const liveItems = document.getElementsByClassName('liveItem');
      const interviewWrapperElement = document.getElementsByClassName('interviewWrapper');
      const paginationWrapperElement = document.getElementsByClassName('paginationWrapper')[0];
      let videoItemMarginRightValue = 0;
      let liveItemMarginRightValue = 0;
      Array.from(videoItems)
        .forEach((item : any) => {
          if (
            videoItemMarginRightValue < 1 &&
            (parseFloat(window.getComputedStyle(item).marginRight, 10) > 0)
          ) {
            videoItemMarginRightValue = parseFloat(window.getComputedStyle(item).marginRight, 10);
          }
        });
      Array.from(liveItems)
        .forEach((item : any) => {
          if (
            liveItemMarginRightValue < 1 &&
            (parseFloat(window.getComputedStyle(item).marginRight, 10) > 0)
          ) {
            liveItemMarginRightValue = parseFloat(window.getComputedStyle(item).marginRight, 10);
          }
        });
      if (videoItems.length > 0) {
        selectableRows = document.getElementsByClassName('selectableRow');
        videoItemMarginRight = videoItemMarginRightValue;
        liveItemMarginRight = liveItemMarginRightValue;
        videoItemWidth = parseFloat(window.getComputedStyle(videoItems[0]).width, 10);
        videoListHeight = parseFloat(window.getComputedStyle(videoListsItems[0]).height, 10);
        tagItemMargin = tagItems.length > 1
          ? (parseFloat(window.getComputedStyle(tagItems[1]).marginRight, 10) +
            parseFloat(window.getComputedStyle(tagItems[1]).marginLeft, 10))
          : null;
        liveItemMargin = liveItems.length > 1
          ? (parseFloat(window.getComputedStyle(liveItems[1]).marginRight, 10) +
            parseFloat(window.getComputedStyle(liveItems[1]).marginLeft, 10))
          : null;
        tagItemWidth = tagItems.length > 0
          ? (parseFloat(window.getComputedStyle(tagItems[0]).width, 10))
          : null;
        liveItemWidth = liveItems.length > 0
          ? (parseFloat(window.getComputedStyle(liveItems[0]).width, 10))
          : null;
        tagListHeight = tagListsItems.length > 0
          ? parseFloat(window.getComputedStyle(tagListsItems[0]).height, 10)
          : null;
        liveListHeight = liveListsItems.length > 0
          ? parseFloat(window.getComputedStyle(liveListsItems[0]).height, 10)
          : null;
        listContainerELement = document.getElementsByClassName('listsContainer')[0];
        interviewWrapper = interviewWrapperElement.length > 0 ? interviewWrapperElement[0] : null;
        interviewHeight = interviewWrapperElement.length > 0 ? window.getComputedStyle(interviewWrapperElement[0]).height : '0px';
        videoLists = videoListsItems;
        tagLists = tagListsItems;
        liveLists = liveListsItems;
        paginationWrapper = paginationWrapperElement;
        setTimeout(() => {
          if (interval) {
            clearInterval(interval);
          }
          const listElement = document.getElementsByClassName('listsContainer')[0];
          if (listElement) {
            listElement.style.marginTop = '0px';
          }
        }, 100);
      }
    }

    interval = setInterval(handleCheckRenderedDom, 500);
    checkHaveActiveItem();
  };

  const checkHaveActiveItem = () : boolean => {
    const selectableRowsGroup = document.getElementsByClassName('selectableRow');
    const lastActive = document.getElementsByClassName('lastActive')[0];
    selectableRows = Array.from(selectableRowsGroup);
    if (selectableRows && selectableRows.length > 0) {
      if (lastActive) {
        lastActive.classList.remove('lastActive', 'activeItem');
      }
      if (selectableRows[0]) {
        selectableRows[0].classList.add('activeRow');
      }
      if (selectableRows[0].getElementsByClassName('selectableItem')[0]) {
        selectableRows[0].getElementsByClassName('selectableItem')[0].classList.add('activeItem', 'lastActive');
      }
    }
    return false;
  };

  // eslint-disable-next-line
  const handleClickActiveItem = () => {
    const activeElement = document.getElementsByClassName('activeItem')[0];
    if (activeElement && !checkElementHasClass(activeElement, 'disableSelection')) {
      if (activeElement && activeElement.getAttribute) {
        const route = activeElement.getAttribute('route');
        const isSeries = activeElement.getAttribute('isseries');
        const clickable = activeElement.getAttribute('clickable');
        if (clickable) {
          activeElement.click();
        }
        if (route && (route !== location.pathname)) {
          history.push({
            pathname: route,
            state: { isSeries },
          });
        }
      }
    }
  };

  const whichChild = (elem) : number => {
    let i = 0;
    while (elem && elem.previousSibling && ((elem = elem.previousSibling) != null)) ++i;
    return i;
  };

  // eslint-disable-next-line
  const verticalMove = (direction) : void => {
    let canChangeActiveRow = true;
    let hasActiveRow = false;
    if (selectableRows && selectableRows.length >= 1) {
      function removeActiveItem(element : any) {
        element.classList.remove('activeRow');
        Array.from(element.getElementsByClassName('selectableItem'))
          .forEach((item : any) => {
            if (checkElementHasClass(item, 'activeItem')) {
              item.classList.remove('activeItem');
            }
          });
      }

      function handleSetActiveItemAfterActiveRowChanged(i : number, type : string) {
        let lastActiveIndex = null;
        const nextActiveIndex = type === 'increment' ? i + 1 : i - 1;
        const selectableItems = selectableRows[nextActiveIndex].getElementsByClassName('selectableItem');
        Array.from(selectableItems)
          .forEach((item : any, lastIndex : number) => {
            if (checkElementHasClass(item, 'lastActive')) {
              lastActiveIndex = lastIndex;
            }
          });
        if (lastActiveIndex) {
          selectableItems[lastActiveIndex].classList.add('activeItem');
        } else if (selectableItems.length > 0) {
          selectableItems[0].classList.add('activeItem', 'lastActive');
        }
      }

      Array.from(selectableRows)
        .forEach((item : any, i : number) => {
          function handleChangeActiveRow(type : string, nextRowIndex? : number, listType? : string) {
            const statement = type === 'increment' ? (i < (selectableRows.length - 1)) : (i > 0);
            const nextIndex = type === 'increment' ? (i + 1) : (i - 1);
            if (statement) {
              canChangeActiveRow = false;
              if (listType !== 'pagination' && (nextRowIndex || nextRowIndex === 0)) {
                listContainerELement.style.transitionDuration = '.2s';
                const newMargin = `-${listType === 'tagList' ? (nextRowIndex * tagListHeight) : listType === 'liveList' ? ((nextRowIndex * liveListHeight) + (tagListHeight || 0)) : ((nextRowIndex * videoListHeight) + (tagListHeight || 0) + (liveListHeight || 0))}px`;
                listContainerELement.style.marginTop = newMargin;
              }
              removeActiveItem(item);
              selectableRows[nextIndex].classList.add('activeRow');
              handleSetActiveItemAfterActiveRowChanged(i, type);
            }
          }

          if (checkElementHasClass(item, 'activeRow')) {
            const activeItem = item.getElementsByClassName('activeItem');
            const activeItemIndex = whichChild(activeItem[0]);
            const selectableItems = item.getElementsByClassName('selectableItem');
            if (
              (!activeItem || activeItem.length < 1) &&
              (selectableItems && selectableItems.length > 0)
            ) {
              selectableItems[0].classList.add('activeItem');
            }
            hasActiveRow = true;
            if (direction === 'up') {
              if (canChangeActiveRow) {
                if (checkElementHasClass(item, 'horizontal-list')) {
                  const allItemsTag = _.map(Array.from([...tagLists, ...liveLists, ...videoLists]), (item : any) => (item && item.getAttribute) && item.getAttribute('rowid'));
                  const activeIndex = ((item.parentNode).parentNode && ((item.parentNode).parentNode).getAttribute) && allItemsTag.indexOf(((item.parentNode).parentNode).getAttribute('rowId'));
                  if ((tagLists.length > 0) && ((item.parentNode).parentNode && ((item.parentNode).parentNode).getAttribute) && allItemsTag.indexOf(((item.parentNode).parentNode).getAttribute('rowId')) === 0) {
                    handleChangeActiveRow('decrement');
                  }
                  Array.from(videoLists)
                    .forEach((videoRow : any, j : number) => {
                      if (((item.parentNode).parentNode && ((item.parentNode).parentNode).getAttribute) && videoRow && videoRow.getAttribute && videoRow.getAttribute('rowid') === ((item.parentNode).parentNode).getAttribute('rowId')) {
                        const nextRowIndex = j - 1;
                        if (
                          nextRowIndex === 0 &&
                          interviewHeight &&
                          videoLists &&
                          videoLists.length > 1 &&
                          interviewWrapper
                        ) {
                          interviewWrapper.style.height = interviewHeight;
                          handleChangeActiveRow('decrement', nextRowIndex);
                        } else if (nextRowIndex >= 0 && canChangeActiveRow) {
                          handleChangeActiveRow('decrement', nextRowIndex);
                        } else if (nextRowIndex < 0) {
                          handleChangeActiveRow('decrement');
                        }
                      }
                    });
                  Array.from(tagLists)
                    .forEach((tagRow : any) => {
                      if (tagRow && tagRow.getAttribute && activeIndex > 0 && (tagRow.getAttribute('rowid') === allItemsTag[activeIndex - 1])) {
                        handleChangeActiveRow('decrement', 0, 'tagList');
                      }
                    });
                  Array.from(liveLists)
                    .forEach((liveRow : any) => {
                      if (liveRow && liveRow.getAttribute && activeIndex > 0 && (liveRow.getAttribute('rowid') === allItemsTag[activeIndex - 1])) {
                        handleChangeActiveRow('decrement', 0, 'liveList');
                      }
                    });
                } else {
                  if (checkElementHasClass(item, 'verticalList')) {
                    if ((activeItemIndex - 5) >= 0) {
                      activeItem[0].classList.remove('lastActive', 'activeItem');
                      selectableItems[activeItemIndex - 5].classList.add('activeItem', 'lastActive');
                      const newMargin = `-${Math.floor((activeItemIndex - 5) / 5) * parseFloat(window.getComputedStyle(activeItem[0]).height, 10)}px`;
                      item.style.marginTop = newMargin;
                    } else {
                      handleChangeActiveRow('decrement');
                    }
                  } else {
                    handleChangeActiveRow('decrement');
                  }
                }
              }
            } else if (direction === 'down') {
              if (canChangeActiveRow) {
                if (checkElementHasClass(item, 'horizontal-list')) {
                  if (videoLists && videoLists.length > 1 && interviewWrapper) {
                    interviewWrapper.style.height = '0px';
                  }
                  if (videoLists && videoLists.length > 0) {
                    Array.from(videoLists)
                      .forEach((videoRow : any, j : number) => {
                        if (videoRow && videoRow.getAttribute && ((item.parentNode).parentNode && ((item.parentNode).parentNode).getAttribute) && videoRow.getAttribute('rowid') === ((item.parentNode).parentNode).getAttribute('rowId')) {
                          const nextRowIndex = j + 1;
                          if (nextRowIndex < videoLists.length && canChangeActiveRow) {
                            handleChangeActiveRow('increment', nextRowIndex, 'videoLists');
                          } else if (paginationWrapper && canChangeActiveRow) {
                            handleChangeActiveRow('increment', nextRowIndex, 'pagination');
                          }
                        }
                      });
                  }
                  if (tagLists && tagLists.length > 0) {
                    Array.from(tagLists)
                      .forEach((tagRow : any, j : number) => {
                        if (((item.parentNode).parentNode && ((item.parentNode).parentNode).getAttribute) && tagRow && tagRow.getAttribute && tagRow.getAttribute('rowid') === ((item.parentNode).parentNode).getAttribute('rowId')) {
                          const nextRowIndex = j + 1;
                          if ((videoLists && videoLists.length > 0) && canChangeActiveRow) {
                            handleChangeActiveRow('increment', nextRowIndex, 'tagList');
                          }
                        }
                      });
                  }
                  if (liveLists && liveLists.length > 0) {
                    Array.from(liveLists)
                      .forEach((liveRow : any, j : number) => {
                        if (((item.parentNode).parentNode && ((item.parentNode).parentNode).getAttribute) && liveRow && liveRow.getAttribute && liveRow.getAttribute('rowid') === ((item.parentNode).parentNode).getAttribute('rowId')) {
                          const nextRowIndex = j + 1;
                          if ((videoLists && videoLists.length > 0) && canChangeActiveRow) {
                            handleChangeActiveRow('increment', nextRowIndex, 'liveList');
                          }
                        }
                      });
                  }
                } else {
                  if (checkElementHasClass(item, 'verticalList')) {
                    if ((activeItemIndex + 5) < (selectableItems.length)) {
                      activeItem[0].classList.remove('lastActive', 'activeItem');
                      selectableItems[activeItemIndex + 5].classList.add('activeItem', 'lastActive');
                      const newMargin = `-${Math.floor((activeItemIndex + 5) / 5) * parseFloat(window.getComputedStyle(activeItem[0]).height, 10)}px`;
                      item.style.marginTop = newMargin;
                    } else if (
                      ((selectableItems.length % 5) === 0)
                      || ((selectableItems.length - (activeItemIndex + 1)) < (selectableItems.length % 5))
                    ) {
                      handleChangeActiveRow('increment');
                    }
                  } else {
                    handleChangeActiveRow('increment');
                  }
                }
              }
            }
          }
        });
      if (!hasActiveRow && (selectableRows.length > 0)) {
        if (selectableRows.length > 1) {
          selectableRows[1].classList.add('activeRow');
        } else {
          selectableRows[0].classList.add('activeRow');
        }
        verticalMove('down');
      }
    }
  };

  // eslint-disable-next-line
  const horizontalMove = (direction) : void => {
    let canChangeAtiveItem = true;

    if (selectableRows && selectableRows.length >= 1) {
      function changeActiveItem(selectableItems : any, element : any, index : number, type : string) {
        const nextItemIndex = type === 'increment' ? index + 1 : index - 1;
        element.classList.remove('lastActive', 'activeItem');
        selectableItems[nextItemIndex].classList.add('lastActive', 'activeItem');
        canChangeAtiveItem = false;
      }

      Array.from(selectableRows)
        .forEach((rowItem : any) => {
          if (checkElementHasClass(rowItem, 'activeRow')) {
            const selectableItems = rowItem.getElementsByClassName('selectableItem');
            Array.from(selectableItems)
              .forEach((item : any, i : number) => {
                if (checkElementHasClass(rowItem, 'horizontal-list')) {
                  const activeIndex = i - 1;
                  if (checkElementHasClass(item, 'activeItem')) {
                    const rowAppearItems = 1;
                    if ((i > 0) && ((selectableItems.length - i) > rowAppearItems)) {
                      let newMargin = null;
                      if (checkElementHasClass(rowItem.parentNode.parentNode, 'tagList')) {
                        newMargin = `-${(direction === 'right' && activeIndex === 1) ? '0px' : `${(tagItemWidth + tagItemMargin) * (direction === 'left' ? activeIndex : (activeIndex > 1) ? activeIndex - 1 : activeIndex)}px`}`;
                      } else if (checkElementHasClass(rowItem.parentNode.parentNode, 'liveList')) {
                        newMargin = `-${(direction === 'right' && activeIndex === 1) ? '0px' : `${(liveItemWidth + liveItemMarginRight) * (direction === 'left' ? activeIndex : (activeIndex > 1) ? activeIndex - 1 : activeIndex)}px`}`;
                      } else {
                        newMargin = `-${(direction === 'right' && activeIndex === 1) ? '0px' : `${(videoItemWidth + videoItemMarginRight) * (direction === 'left' ? activeIndex : (activeIndex > 1) ? activeIndex - 1 : activeIndex)}px`}`;
                      }
                      rowItem.style[isRTL ? 'marginRight' : 'marginLeft'] = newMargin;
                    }
                  }
                }
                if (checkElementHasClass(item, 'activeItem') && canChangeAtiveItem) {
                  if (checkElementHasClass(rowItem, 'verticalList')) {
                    if (direction === 'left') {
                      const currentRowIndex = Math.floor((whichChild(item) + 1) / 5);
                      if ((selectableItems.length / 5) > currentRowIndex) {
                        const listMargin = `-${currentRowIndex * parseFloat(window.getComputedStyle(item).height, 10)}px`;
                        if (listMargin !== rowItem.style.marginTop) {
                          rowItem.style.marginTop = listMargin;
                        }
                      }
                    } else {
                      const currentRowIndex = Math.floor((whichChild(item) - 1) / 5);
                      if (currentRowIndex >= 0) {
                        const listMargin = `-${currentRowIndex * parseFloat(window.getComputedStyle(item).height, 10)}px`;
                        if (listMargin !== rowItem.style.marginTop) {
                          rowItem.style.marginTop = listMargin;
                        }
                      }
                    }
                  }
                  if (direction === 'right' && i > 0) {
                    changeActiveItem(selectableItems, item, i, 'decrement');
                  } else if (direction === 'left' && (i < (selectableItems.length - 1))) {
                    changeActiveItem(selectableItems, item, i, 'increment');
                  }
                }
              });
          }
        });
    }
  };

  return (
    <div className="keyControlWrapper">
      <Suspense fallback={<Loading />}>
        {
          !_.get(window, ['webOS', 'platform', 'tv']) && (
            <Controls
              onLeft={() => horizontalMove('left')}
              onRight={() => horizontalMove('right')}
              onUp={() => verticalMove('up')}
              onDown={() => verticalMove('down')}
              onOk={() => handleClickActiveItem()}
            />
          )
        }
        <Switch>
          <SentryRoute path="/:lang/search" component={Search} />
          <SentryRoute path="/:lang/profile" component={Profile} />
          <SentryRoute
            path="/:lang/signin"
            render={({ match, ...rest } : any) => (_.get(process.env.APP_CONFIG, ['APP_DETAILS', 'EN_NAME'], '') === 'Filimo') ? (
              <DirectLogin {...rest} checkRenderedDom={checkRenderedDom} />
            ) : (
              <Login
                {...rest}
                match={match}
              />
            )}
          />
          <SentryRoute
            path="/:lang/grid/:id"
            render={({ match, ...rest } : any) => (
              <Grid
                {...rest}
                match={match}
                checkRenderedDom={checkRenderedDom}
                verticalMove={verticalMove}
              />
            )}
          />
          <SentryRoute
            path="/:lang/details/:id"
            render={({ match, ...rest } : any) => (
              <Details {...rest} match={match} />
            )}
          />
          <SentryRoute
            path="/:lang/m/:id"
            render={({ match, ...rest } : any) => (
              <Preview {...rest} match={match} />
            )}
          />
          <SentryRoute
            path="/:lang/w/:id"
            render={({ match, ...rest } : any) => (
              <Play {...rest} match={match} />
            )}
          />
          <SentryRoute
            path="/:lang/l/:id"
            render={({ match, ...rest } : any) => (
              <LiveTv {...rest} match={match} />
            )}
          />
          <SentryRoute
            path="/:lang/c/:id"
            render={({ match, ...rest } : any) => (
              <LiveAparat {...rest} match={match} />
            )}
          />
          <SentryRoute
            path="/:lang/bookmarks"
            render={({ match, ...rest } : any) => (
              <Bookmarks {...rest} match={match} />
            )}
          />
          <SentryRoute
            path="/:lang/payment"
            render={({ match, ...rest } : any) => (
              <Payment {...rest} match={match} checkRenderedDom={checkRenderedDom} />
            )}
          />
          <SentryRoute
            path="/:lang/:tag_id?"
            render={({ match, ...rest } : any) => (
              <Home
                {...rest}
                checkRenderedDom={checkRenderedDom}
                verticalMove={verticalMove}
                match={match}
              />
            )}
          />
        </Switch>
      </Suspense>
    </div>
  );
}
